<template>
  <dialog
    class="modal z-[5]"
    @keyup.esc="close"
    @mousedown="modalOutsideClicked"
  >
    <section
      class="modal-container"
      :class="size"
    >
      <button
        class="btn-close"
        @click="close"
      >
        <FontAwesomeIcon :icon="faXmark" />
        <span class="sr-only">Close</span>
      </button>

      <div class="modal-content">
        <header
          v-if="$slots.header"
          class="header"
        >
          <slot name="header" />
        </header>

        <article class="body">
          <slot />
        </article>

        <footer
          v-if="$slots.footer"
          class="footer"
        >
          <slot name="footer" />
        </footer>
      </div>
    </section>
  </dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useDisableBodyScroll } from '@/composables';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);

const close = () => {
  if (!props.disabled) {
    emit('close');
  }
};

const modalOutsideClicked = (event) => {
  if (event.target.classList.contains('modal')) {
    close();
  }
};

const isScrollDisabled = ref(false);

onMounted(() => {
  useDisableBodyScroll(isScrollDisabled);
  isScrollDisabled.value = true;
});

</script>
